export const HEALTH_DEGRADATION_WARNING = 50;
export const HEALTH_DEGRADATION_ALERT = 25;
export const HEALTH_DEGRADATION_WARNING_PRECENTAGE = HEALTH_DEGRADATION_WARNING / 100;
export const HEALTH_DEGRADATION_ALERT_PERCENTAGE = HEALTH_DEGRADATION_ALERT / 100;
